import { Pager, SalesOrder, TeamSalesOrderPhase } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQueries, useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';


/**
 * 1210. 受注案件一覧
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders
 */
type Props = {
  identifier: string;
  team_id: number;
  page: number;
  per: number;
  team_sales_order_phase_ids?: number[];
  user_ids?: number[];
  business_partner_ids?: number[];
  my_project?: boolean;
  archived?: boolean;
  name?: string;
  enabled?: boolean;
}

export type SalesOrderResponse = {
  sales_orders: SalesOrder[];
  pager: Pager;
}

const salesOrders = (props: Props): Promise<SalesOrderResponse> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders`, { params: props });
};

export const useSalesOrders = (props: Props) => {
  return useQuery({
    queryKey: [
      'workspaces',
      props.identifier,
      'teams',
      props.team_id,
      'sales_orders',
      'pager',
      props.page,
      props.per,
      props.team_sales_order_phase_ids,
      props.user_ids,
      props.business_partner_ids,
      props.my_project,
      props.archived,
      props.name,
    ],
    queryFn: () => salesOrders(props),
    enabled: props.enabled
  });
};

export const useSalesOrdersPerPhase = (phases: TeamSalesOrderPhase[], props: Props) => {
  return useQueries({
    queries: phases ? phases.map((phase) => {
      const params = { ...props, team_sales_order_phase_ids: [phase.id] };
      return {
        queryKey: [{ ...params }],
        queryFn: () => salesOrders(params)
      };
    }) : []
  });
};

export const useSalesOrdersInvalidate = (identifier: string, team_id: number) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['workspaces', identifier, 'teams', team_id, 'sales_orders'] });
  };

  return { invalidate };
};